import React, {Component} from 'react';

import '../../sass/questions.scss';
import FaqItem from '../faq/FaqItem';

class QuestionsSite extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        const { name, faq, bg } = this.props;

        var listItemFaq = [];
        for (let i=0; i<faq.length;i++) {
            listItemFaq.push(<FaqItem key={i} data={faq[i]} />);
        }

        let classContent = "question-sity";
        if(bg) classContent = "question-sity bg";

        return (
            <aside className={classContent}>
                <div className="content">
                    <div className="name">{name}</div>
                    {listItemFaq}
                </div>
            </aside>
        )
    }
}

export default QuestionsSite;


// WEBPACK FOOTER //
// ./src/components/faq/QuestionsSite.js